import React from "react";
import { whatsappLink } from "../lib/constants";

export default function FloatingWhatsApp() {
    return (
        <a
            href={whatsappLink()}
            target="_blank"
            rel="noreferrer"
            aria-label="Chat on WhatsApp"
            data-testid="floating-whatsapp-btn"
            className="fixed bottom-6 right-6 z-[60] group"
        >
            <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-60 animate-ping" />
            <span className="relative flex items-center justify-center h-14 w-14 md:h-16 md:w-16 rounded-full bg-[#25D366] text-white shadow-xl group-hover:-translate-y-1 transition-transform">
                <svg viewBox="0 0 32 32" className="h-7 w-7 md:h-8 md:w-8 fill-current" aria-hidden="true">
                    <path d="M19.11 17.29c-.28-.14-1.68-.83-1.94-.92-.26-.09-.45-.14-.64.14-.19.28-.73.92-.9 1.11-.17.19-.33.21-.61.07-.28-.14-1.19-.44-2.26-1.4-.84-.75-1.4-1.67-1.56-1.95-.16-.28-.02-.43.12-.57.13-.13.28-.33.42-.49.14-.17.19-.28.28-.47.09-.19.05-.35-.02-.49-.07-.14-.64-1.55-.88-2.12-.23-.55-.47-.48-.64-.49l-.55-.01c-.19 0-.49.07-.75.35-.26.28-.99.97-.99 2.36 0 1.39 1.01 2.74 1.15 2.93.14.19 1.99 3.04 4.82 4.26.67.29 1.2.47 1.61.6.68.22 1.29.19 1.78.12.54-.08 1.68-.69 1.92-1.35.24-.66.24-1.23.17-1.35-.07-.12-.26-.19-.54-.33zM16.01 4C9.38 4 4 9.38 4 16.01c0 2.12.55 4.12 1.6 5.9L4 28l6.22-1.6a11.93 11.93 0 0 0 5.79 1.48h.01c6.62 0 12-5.38 12-12.01C28.02 9.38 22.63 4 16.01 4z" />
                </svg>
            </span>
        </a>
    );
}
